import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { HolidayItem } from "@/services/entities/HolidayItem";
import DxDataGrid, {
    DxColumn,
    DxFilterRow, DxPager,
    DxPaging,
    DxHeaderFilter,
    DxStateStoring,
    DxButton,
} from "devextreme-vue/data-grid";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HolidayTable',
  props: {
    data: { Type: [] as HolidayItem[], default: [] as HolidayItem[] },
},
  emits: ['delete', 'edit'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const selectedKeys = ref([] as number[]);

const props = __props;

function editHoliday(item: any) {
    selectedKeys.value = [item.row.data.id];
    emit('edit', item.row.data.id)
}
function deleteHoliday(item: any) {
    emit('delete', item.row.data.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.data,
    id: "holidayGridContainer",
    "selected-row-keys": selectedKeys.value,
    "auto-navigate-to-focused-row": true,
    "key-expr": "id"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        "data-type": "string",
        caption: "ID",
        visible: false
      }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "holidayGridContainer"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "date",
        "data-type": "date",
        caption: "Date",
        format: "dd/MM/yyyy"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "name",
        "data-type": "string",
        caption: "Name"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "description",
        "data-type": "string",
        caption: "Description"
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: 70
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "Edit holiday",
            icon: "edit",
            "styling-mode": "contained",
            type: "normal",
            onClick: editHoliday
          }),
          _createVNode(_unref(DxButton), {
            hint: "Delete holiday",
            icon: "trash",
            "styling-mode": "contained",
            type: "normal",
            onClick: deleteHoliday
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxPaging), { "page-size": 10 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "selected-row-keys"]))
}
}

})